import { rootElement } from '@shared/setup';
import ImageLibraryRoot from './ImageLibraryRoot.vue';

const initImageLibraryRoot = async () => {
    rootElement({
        name: 'ImageLibraryRoot', // pascal, camel & kebab-case are valid
        component: ImageLibraryRoot,
        vm: {},
        contextComponents: ['<div>Waiting...</div>'],
    });
};

initImageLibraryRoot();
